// Simple i18n setup for basic English text only
// Google Translate handles all other languages

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Basic English translations - Google Translate will handle other languages
const enTranslations = {
  app: {
    title: "Kundli Shastra",
    subtitle: "Personalised Kundli Analysis",
    heroDescription: "Get your Vedic astrology birth chart (Kundli) with planetary positions, divisional charts, astrological insights, and numerology. Instant and precise calculations.",
    calculateYourKundli: "Calculate Your Kundli",
    enterBirthDetails: "Enter your birth details to get started",
    birthDate: "Birth Date",
    birthTime: "Birth Time",
    birthPlace: "Birth Place",
    calculate: "Calculate Kundli",
    calculating: "Calculating...",
    error: "Error",
    viewDashboard: "View Full Dashboard",
    astrologicalChart: "Your Astrological Chart",
    chartSubtitle: "Your personalized birth chart insights",
    lagna: "Lagna",
    ascendant: "Ascendant",
    chandraRashi: "Chandra Rashi",
    moonSign: "Moon Sign",
    nakshatra: "Nakshatra",
    star: "Birth Star",
    pada: "Pada"
  },
  dashboard: {
    title: "Your Personal Kundli Insights",
    subtitle: "Complete birth chart analysis",
    birthChart: "Birth Chart (D1)",
    tabs: {
      overview: "Overview",
      planets: "Planets",
      charts: "Divisional Charts",
      predictions: "Predictions",
      mahadasha: "Mahadasha",
      insights: "Insights",
      karmic: "Karmic Insights",
      numerology: "Numerology"
    }
  }
};

const resources = {
  en: { translation: enTranslations }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;

